import * as React from 'react';
import { Layout } from 'react-admin';
import AppBar from './AppBar';
import Menu from './Menu';
import {useEffect} from "react";

export default ({ children }: { children: React.ReactNode }) => {

    useEffect(() => {
        document.title = "捷可印-部落格-後台系統";
    }, []);

    return (
        <Layout appBar={AppBar} menu={Menu}>
            {children}
        </Layout>
    )
};
